<form #createEquipeForm="ngForm">

    <app-custom-modal #modal title="Editar sala" subtitle="Edite a sala para gerenciar agendamentos"
        (onCloseClick)="modal.close()" (onSaveClick)="save()" saveLabel="Salvar Sala"
        buttonImage="hgi hgi-stroke hgi-tick-01 icon-color-black" hideCancel [saveDisabled]="createEquipeForm.invalid">
        <div class="container">
            <div class="mb-4">
                <label for="nome" class="form-label required">Nome da sala</label>
                <input type="text" class="form-control" name="nome" maxlength="150" [(ngModel)]="agenda.nomeSala"
                    #nomeModel="ngModel" #nomeEl id="nome" required placeholder="Digite aqui" />
                <abp-validation-summary [control]="nomeModel" [controlEl]="nomeEl"></abp-validation-summary>
            </div>

            <div class="mb-4">
                <label for="integrantes" class="form-label">Integrantes</label>
                <div *ngIf="appSession.clinicaId" class="input-group mb-4">
                    <div class="input-group-prepend">
                        <span class="input-group-text" id="basic-addon1">
                            <i class="hgi hgi-stroke hgi-search-01"></i>
                        </span>
                    </div>
                    <input type="text" class="form-control" name="keyword" placeholder="Adicione integrantes pelo Nome"
                        (ngModelChange)="atualizarLista($event)" [(ngModel)]="nome">
                </div>

                <div *ngIf="profissionaisFiltrados.length > 0 && appSession.clinicaId"
                    class="card mt-4 scroll-container">
                    <div *ngFor="let profissional of profissionaisFiltrados">
                        <div class="mt-2" (click)="insertProfissional(profissional)"
                            class="row d-flex align-items-center profissional-container">
                            <div class="col-auto">
                                <div class="user-foto-container">
                                    <img src="../../../../../assets/img/user.png" alt="Foto do usuário">
                                </div>
                            </div>
                            <div class="col-auto d-flex flex-column justify-content-start p-0">
                                <p class="nome-profissional">{{ profissional.nome }}</p>
                                <p class="cpf-profissional">{{ profissional.cpf | cpfCnpj}}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="profissionaisSelecionados.length > 0" class="scroll-container">
                    <div class="mt-4" *ngFor="let profissional of profissionaisSelecionados">
                        <div class="row d-flex align-items-center" (click)="insertProfissional(profissional)">
                            <div class="col-auto d-flex align-items-center">
                                <div class="user-foto-container">
                                    <img src="../../../../../assets/img/user.png" alt="Foto do usuário">
                                </div>
                            </div>
                            <div class="col d-flex align-items-center justify-content-between">
                                <div class="d-flex flex-column">
                                    <p class="nome-profissional m-0">{{ profissional.nome }}</p>
                                    <p class="cpf-profissional m-0">{{ profissional.cpf | cpfCnpj }}</p>
                                </div>
                                <div *ngIf="appSession.clinicaId" class="d-flex align-items-center">
                                    <button class="btn icon icon-danger" title="Remover do grupo"
                                        (click)="removeProfissional(profissional); $event.stopPropagation()">
                                        <i class="hgi hgi-stroke hgi-delete-02"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

            <div class="mb-4">
                <label class="form-label required">Tipo de Sala</label>
                <div class="d-flex gap-3">
                    <div class="form-check">
                        <input type="radio" class="form-check-input" name="tipoSala" id="consultorio"
                            [(ngModel)]="agenda.tipoSala" [value]="TipoSala._0" required />
                        <label class="form-check-label" for="consultorio">Consultório</label>
                    </div>
                    <div class="form-check ml-4">
                        <input type="radio" class="form-check-input" name="tipoSala" id="salaDeExames"
                            [(ngModel)]="agenda.tipoSala" [value]="TipoSala._1" required />
                        <label class="form-check-label" for="salaDeExames">Sala de Exames</label>
                    </div>
                </div>
            </div>

            <div class="form-row mb-4">
                <div class="col">
                    <label for="nome" class="form-label required">Horário Inicio</label>
                    <input type="time" class="form-control" name="hora-inicio" [(ngModel)]="agenda.horarioInicio"
                        required placeholder="Digite aqui" />
                    <abp-validation-summary [control]="nomeModel" [controlEl]="nomeEl"></abp-validation-summary>
                </div>
                <div class="col">
                    <label for="nome" class="form-label required">Horário Fim</label>
                    <input type="time" class="form-control" name="hora-fim" [(ngModel)]="agenda.horarioFim" required
                        placeholder="Digite aqui" />
                    <abp-validation-summary [control]="nomeModel" [controlEl]="nomeEl"></abp-validation-summary>
                </div>
            </div>
            <div class="mb-4">
                <div class="row">
                    <label for="duracaoConsulta" class="form-label required">Duração da Consulta</label>
                </div>
                <div class="row">
                    <select name="duracaoConsulta" id="duracaoConsulta" required class="form-control"
                        [value]="undefined" [(ngModel)]="agenda.duracaoConsulta" #duracaoConsultaModel="ngModel"
                        #duracaoConsultaEl>
                        <option [value]="undefined" disabled selected class="option-placeholder">Selecione</option>
                        <option *ngFor="let tempo of tempoConsultas" [ngValue]="tempo.value">{{tempo.name}}</option>
                    </select>

                    <abp-validation-summary [control]="duracaoConsultaModel"
                        [controlEl]="duracaoConsultaEl"></abp-validation-summary>
                </div>
            </div>

            <div class="mt-2">
                <button type="button" class="btn-agenda" [class]="suspenso ? 'btn btn-warning w-100' : 'btn btn-outline-warning w-100'"
                    (click)="alternarSuspensao()">
                    <i class="hgi hgi-stroke hgi-pause-circle mr-2"></i>
                    {{ suspenso ? 'Remover Suspensão' : 'Suspender Sala' }}
                </button>
            </div>
            <div class="mt-2">
                <button type="button" class="btn btn-agenda btn-danger w-100 p-4" (click)="excluirAgenda()">
                    <i class="hgi hgi-stroke hgi-delete-02 mr-2"></i> Excluir Sala
                </button>
            </div>
        </div>
    </app-custom-modal>
</form>
